import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import QueryGridPage from './query-grid/query-grid.page';
import { SiTrackPage } from '../../components/si-track-page';
import { useSaveData } from '../../hooks/useSaveData';
import { queryBuilderApiKeyStore } from '../../api/query-builder-api-key-store';
import { LoadingIndicator } from '../../components/loading-indicator.component';
import { ReactHookForm } from '../../components/hook-form/react-hook-form.component';
import { useReactHookForm } from '../../hooks/useReactHookForm';
import { Button, Grid } from '@mui/material';
import dayjs from 'dayjs';
import FormDateField, { DateFormat } from '../../components/hook-form/form-date.field.component';
import { FormAutoCompleteMultiSelectDynamic } from '../../components/hook-form/form-autocomplete-multi-select.dynamic.component';
import { FormAutoCompleteSelectDynamic } from '../../components/hook-form/form-autocomplete-select.dynamic.component';
import { workorderReportApiKeyStore } from '../../api/workorder-report-api-key-store';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';

const ExecuteReport = () => {
  const { reportName } = useParams();
  const formForDateFields = useReactHookForm({
    defaultValues: {},
    // yupSchema: filtersSchema,
  });
  const reportDecodeName = !reportName ? reportName : decodeURIComponent(reportName);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const reportId = searchParams.get('reportId');

  const { isLoading, mutateAsync, data } = useSaveData<any[]>(queryBuilderApiKeyStore.excecuteReport());

  useEffect(() => {
    if (reportName) {
      const payload = {
        reportId: Number(reportId) || 0,
        reportName: reportDecodeName || '',
        dateCriterias: [],
        dateFrom: '',
        dateTo: '',
      };
      mutateAsync({ data: payload });
      formForDateFields.setValue('fromDate', undefined);
      formForDateFields.setValue('toDate', undefined);
      formForDateFields.setValue('dateCriteria', []);
    }
  }, [reportName]);

  const handleSubmit = (data: any) => {
    const dateCriteria = !data?.dateCriteria ? [] : data?.dateCriteria?.map((item: any) => item?.dateCriteriaValue);
    const payload = {
      reportId: Number(reportId) || 0,
      reportName: reportDecodeName || '',
      dateCriterias: dateCriteria,
      dateFrom: !data?.fromDate ? '' : data?.fromDate,
      dateTo: !data?.toDate ? '' : data?.toDate,
    };
    mutateAsync({ data: payload });
  };
  const isMultiSelectReportEnabled = true;

  const handleDateCriteria = (value: any) => {
    if (value?.length > 0) {
      formForDateFields.setValue('fromDate', dayjs().subtract(2, 'week').format(DateFormat.SIMPLE_DATE));
      formForDateFields.setValue('toDate', dayjs().format(DateFormat.SIMPLE_DATE));
    } else {
      formForDateFields.setValue('fromDate', undefined);
      formForDateFields.setValue('toDate', undefined);
    }
  };

  return (
    <SiTrackPage title="Custom Report">
      {isLoading && <LoadingIndicator isLoading={isLoading} />}
      {data && (
        <div className="innerContent">
          {(data?.data || !!formForDateFields.watch('dateCriteria')) && (
            <ReactHookForm
              formName="QUERY_BUILDER_DATE_FORM"
              onSubmit={handleSubmit}
              formContextProps={formForDateFields}
            >
              <Grid container spacing={1} style={{ padding: 12 }}>
                <Grid item lg={12} sm={12} xl={12} xs={12}>
                  <Grid container spacing={1}>
                    <Grid item xl={3} lg={3} sm={4} xs={6}>
                      {isMultiSelectReportEnabled ? (
                        <FormAutoCompleteMultiSelectDynamic
                          name="dateCriteria"
                          label="Date Criteria"
                          onChange={handleDateCriteria}
                          getQueryKeyConfig={() => workorderReportApiKeyStore.getWorkOrderReportDateCriteria()}
                          optionsLabelKey="dateCriteria"
                          optionsValueKey="dateCriteriaValue"
                        />
                      ) : (
                        <FormAutoCompleteSelectDynamic
                          name="dateCriteria"
                          label="Date Criteria"
                          // onChange={handleStatusChange}
                          getQueryKeyConfig={() => workorderReportApiKeyStore.getWorkOrderReportDateCriteria()}
                          optionsValueKey="dateCriteriaValue"
                          optionsLabelKey="dateCriteria"
                        />
                      )}
                    </Grid>
                    <Grid item xl={1.5} lg={1.5} sm={4} xs={6}>
                      <FormDateField
                        label={'Date From'}
                        name="fromDate"
                        disabled={
                          !formForDateFields.watch('dateCriteria') ||
                          formForDateFields.watch('dateCriteria')?.length === 0
                        }
                        format={DateFormat.SIMPLE_DATE}
                        dateLimits={{
                          maxDateEnabled: true,
                          maxDateValue: 'toDate',
                        }}
                      />
                    </Grid>
                    <Grid item xl={1.5} lg={1.5} sm={4} xs={6}>
                      <FormDateField
                        label={'Date To'}
                        name="toDate"
                        disabled={
                          !formForDateFields.watch('dateCriteria') ||
                          formForDateFields.watch('dateCriteria')?.length === 0
                        }
                        format={DateFormat.SIMPLE_DATE}
                        dateLimits={{
                          minDateEnabled: true,
                          minDateValue: 'fromDate',
                        }}
                      />
                    </Grid>
                    <Grid item xl={4} lg={4} sm={4} xs={6}>
                      <Grid container direction="row" justifyContent="flex-start" alignItems="center">
                        <Button
                          disabled={
                            !formForDateFields.watch('dateCriteria') ||
                            formForDateFields.watch('dateCriteria')?.length === 0
                          }
                          type="submit"
                          title="Filter"
                          variant="contained"
                          startIcon={<FilterAltOutlinedIcon />}
                        >
                          Filter
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </ReactHookForm>
          )}
          <QueryGridPage queryResult={data?.data} />
        </div>
      )}
    </SiTrackPage>
  );
};

export default ExecuteReport;
